import { render, staticRenderFns } from "./FormFeedback.vue?vue&type=template&id=61776600&scoped=true&"
import script from "./FormFeedback.vue?vue&type=script&lang=js&"
export * from "./FormFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61776600",
  null
  
)

export default component.exports